<template lang="pug">
  v-container(fluid class="pt-0 px-0")
    span(class="company-name") {{ complexItem.companyName }} -
    Title(:title-name="complexItem.name" class="mb-7 d-inline-block ml-2")
    v-card(outlined class="mb-8")
      v-row(no-gutters)
        v-col(cols="8")
          ComplexCarousel(:photos="complexItem.photos")
        v-col(cols="4" class="px-10 py-4 d-flex flex-column justify-space-between")
          div
            div(class="text-grey text-center mb-11") г. Бишкек / {{ complexItem.address }}
            v-row(justify="center")
              div(class="text-price mb-3") От {{ parseInt(complexItem.costPerM2).toLocaleString('ru-Ru') }} $
              div(class="text-right mb-3").
                Квартиры от {{ complexItem.areaOfApartmentsFrom }} до {{ complexItem.areaOfApartmentsTo }} м²
              div(
                class="text-right"
                v-if="complexItem.quarterFinish && complexItem.yearFinish").
                  Срок сдачи {{ complexItem.quarterFinish }} кв. {{ complexItem.yearFinish }} г.
          div
            v-btn(
              v-if="!showTel",
              block,
              large,
              depressed,
              class="font-weight-bold",
              color="#B0DF5B",
              @click="showTel = true") Показать #[span(class="text-lowercase pl-1") телефон]
            v-btn(
              v-else,
              disabled,
              depressed,
              large,
              block) {{ parseInt(complexItem.phone).toLocaleString('ru-Ru') }}
          div
            v-row(no-gutters justify="center" align="center" class="mb-3")
              v-icon(color="#B9B9B9" class="mr-2") mdi-domain
              router-link(:to="`/company/list/${complexItem.companyId}`") Застройщик
            v-row(no-gutters justify="center")
              div(class="mr-4")
                v-icon(class="mr-2" color="#B9B9B9") visibility
                span(class="text-views") {{ complexItem.countViews }}
              div
                span(class="text-views") {{ moment(complexItem.creationDate).format('LL') }}
    v-row
      v-col(cols="9")
        Title(title-name="Описание" class="mb-2")
        v-row(no-gutters align="center" justify="start" class="mr-6")
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Число квартир:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ complexItem.numberOfApartments }}
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Высота потолков:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ complexItem.ceilingHeight }} м
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Этажность:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ complexItem.numberOfFloors }}
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Тип дома:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ displayBuildingType }}
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Тип отделки:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ typeOfApartmentFinishes }}
          v-col(cols="6" class="d-flex justify-space-between py-0 px-6")
            span(class="subtitle-1") Тип парковки:
            span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ parkingType }}
        v-divider(class="my-3")
        p {{ complexItem.description }}
        v-divider(class="my-3")
        v-row(no-gutters class="mb-6")
          AdvertsMap(
            v-if="complexItem.point",
            :point="complexItem.point",
            style="height: 350px; border-radius: 6px;")
          v-img(
            v-else,
            :src="require('@/assets/images/noimage.png')",
            height=350,
            aspect-ratio=1.7,
            style="border:1px solid #E0E0E0;border-radius: 6px;")
        v-row(no-gutters)
          v-img(
            :src="require('@/assets/banners/banner-advert-page-horizontal.svg')",
            style="border-radius: 6px;")
      v-col(cols="3")
        div(class="banner")
          v-img(
            :src="require('@/assets/banners/banner-advert-page-vertical.jpg')",
            style="border-radius: 3px;")
</template>
<script>
import Title from '@/components/Adverts/AddNew/Title'
import ComplexCarousel from '@/components/Complex/ComplexCarousel'
import AdvertsMap from '@/components/Adverts/AdvertsMap'
export default {
  name: 'ComplexPage',
  components: { AdvertsMap, ComplexCarousel, Title },
  data: () => ({
    showTel: false,
    visible: false,
    loading: false
  }),
  computed: {
    complexItem() {
      return this.$store.state.complex.complexItem
    },
    // eslint-disable-next-line vue/return-in-computed-property
    displayBuildingType() {
      const type = this.$store.state.complex.complexItem.typeOfBuilding
      if (type) {
        switch (type) {
          case 'brick':
            return 'Кирпич'
          case 'panel':
            return 'Панельный'
          case 'monolith':
            return 'Монолит'
          case 'brickMonolith':
            return 'Кирпич-монолит'
          case 'block':
            return 'Блок'
          default:
            return 'Не указан'
        }
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    typeOfApartmentFinishes() {
      const type = this.$store.state.complex.complexItem.typeOfApartmentFinishes
      if (type) {
        switch (type) {
          case 'hasFinished':
            return 'Под ключ'
          case 'forSelfFinishing':
            return 'Для самостоятельной отделки'
          default:
            return 'Не указан'
        }
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    parkingType() {
      const type = this.$store.state.complex.complexItem.parkingType
      if (type) {
        switch (type) {
          case 'forSell':
            return 'Для продажи'
          case 'notForSell':
            return 'Недоступно для продажи'
          default:
            return 'Не указан'
        }
      }
    }
  },
  created() {
    this.$store.dispatch('GET_COMPLEX_ITEM', this.$route.params.id)
  },
  methods: {
    handleHide() {
      this.visible = false
    },
    handleShow() {
      this.visible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.company-name {
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  letter-spacing: -1.25905px;
  color: #000000;
}
.text {
  &-title {
    font-size: 24px;
    letter-spacing: -1.6px;
    color: #292929;
  }
  &-grey {
    font-size: 12px;
    line-height: 16px;
    color: #8e8e93;
  }
  &-price {
    font-size: 32px;
    font-weight: 700;
    color: #000000;
  }
}
.theme--light.v-btn.v-btn--disabled {
  color: #333 !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.banner {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 1rem;
}
</style>
